import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ArrowRight } from "lucide-react";

export const homeFaqs = [
  {
    question: "What states do you deliver to?",
    answer:
      "We deliver to Queensland (QLD), New South Wales (NSW), Victoria (VIC), and South Australia (SA). We have warehouses in Virginia & Darra (QLD), Mount Druitt (NSW), Truganina (VIC), and Ridleyton (SA). Click & Collect is also available.",
  },
  {
    question: "Do you offer bulk or trade pricing?",
    answer:
      "Yes! We offer competitive pricing for bulk orders and trade accounts with flexible credit terms. Submit a quote request with your requirements and our team will provide tailored pricing within 24-48 hours.",
  },
  {
    question: "Are your products suitable for pets and children?",
    answer:
      "Absolutely. Our artificial grass and outdoor products are non-toxic, lead-free, and designed to be safe for pets and children. They're also easy to clean and maintain.",
  },
  {
    question: "What warranty do your products come with?",
    answer:
      "Our products come with manufacturer warranties ranging from 5 to 15 years depending on the product line. For example, Supreme Wet Wall Panels include a 10-year warranty. All products meet Australian standards for quality and safety.",
  },
  {
    question: "How do I choose the right product for my project?",
    answer:
      "Our team can help! Contact us with your project details and we'll recommend the best products for your needs. We consider factors like usage, climate, and budget. You can also order sample kits for most products.",
  },
  {
    question: "What is the lead time for orders?",
    answer:
      "In-stock items are typically dispatched within 1–3 business days. Metro deliveries arrive within 3–7 business days after dispatch. For bulk orders or custom requirements, request a quote for accurate lead times.",
  },
];

export function FAQSection() {
  return (
    <section className="section-padding bg-background">
      <div className="container max-w-3xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-10"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground">
            Quick answers to common questions about our products and services.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {homeFaqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="rounded-lg border bg-card px-6 shadow-sm"
              >
                <AccordionTrigger className="text-left font-semibold hover:no-underline py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 0.5 }}
          className="text-center mt-10"
        >
          <p className="text-muted-foreground mb-4">Still have questions?</p>
          <Button asChild variant="outline" size="lg">
            <Link to="/quote" className="group">
              Get a Quote
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
        </motion.div>
      </div>
    </section>
  );
}
